import { render, staticRenderFns } from "./ClienteEventos.vue?vue&type=template&id=6b391156"
import script from "./ClienteEventos.vue?vue&type=script&lang=js"
export * from "./ClienteEventos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports